<template>
<div class="container">
  <div class="card" :class="showForm ? '' : 'card-hidden'">
    <div class="row">
      <div class="col-sm-6 login">
        <h4>Entre</h4>
        <form @submit.prevent="login" class="form-auth-small">
          <b-form-group label="Email">
            <b-form-input v-model="email" />
          </b-form-group>
          <b-form-group label="Senha">
            <b-form-input v-model="password" type="password" />
          </b-form-group>
          <button type="submit" class="btn btn-primary btn-lg">Continuar</button>
          <button v-if="isLoading" type="button" class="btn btn-default btn-block"><i class="fa fa-spinner fa-spin"></i> Fazendo login...</button>
          <b-alert variant="danger" show v-if="error">{{error}}</b-alert>
        </form>
      </div>
      <div class="col-sm-6 register">
        <h4 class="card-title">Cadastre-se</h4>
        <form @submit.prevent="register" class="form-auth-small">
          <b-form-group label="Nome *">
            <b-form-input v-model="form.name" v-validate="'required'" name="name" />
            <field-error :msg="veeErrors" field="name" />
          </b-form-group>
          <b-form-group label="CPF/CNPJ *">
            <b-form-input v-model="form.cnpj" v-validate="'required'" name="cnpj" v-mask="['###.###.###-##', '##.###.###/####-##']" />
            <field-error :msg="veeErrors" field="cnpj" />
          </b-form-group>
          <b-form-group label="Categoria *">
            <b-form-select v-model="form.category" v-validate="'required'" name="category" :options="categorias_de_clientes" />
            <field-error :msg="veeErrors" field="category" />
          </b-form-group>
          <b-form-group label="Endereço *">
            <span v-if="form.address" class="text-black">{{form.address.description}}</span>
            <location :cb="setAddress" :current_address="form.address" :autoload="false" />
          </b-form-group>
          <b-form-group label="Telefone *">
            <b-form-input v-model="form.phone" v-validate="'required'" name="phone" placeholder="(99) 99999-9999" v-mask="['(##) ####-####', '(##) #####-####']" />
            <field-error :msg="veeErrors" field="phone" />
          </b-form-group>
          <b-form-group label="Email *">
            <b-form-input v-model="form.email" v-validate="'email|required'" name="email" />
            <field-error :msg="veeErrors" field="email" />
            <div class="text-right" v-if="isEditing()">
              <a class="pointer" @click="changePassword">Alterar senha</a>
            </div>
          </b-form-group>
          <b-form-group label="Senha *">
            <b-form-input v-model="form.password" type="password" v-validate="'required'" name="pass" />
            <field-error :msg="veeErrors" field="pass" />
          </b-form-group>
          <b-form-group label="Confirmar senha *">
            <b-form-input v-model="form.password_confirmation" type="password" v-validate="'required'" name="pass_confirmation" />
            <field-error :msg="veeErrors" field="pass_confirmation" />
          </b-form-group>
          <button type="submit" class="btn btn-primary btn-lg">Continuar</button>
          <button v-if="isLoading" type="button" class="btn btn-default btn-block"><i class="fa fa-spinner fa-spin"></i> Fazendo login...</button>
          <b-alert variant="danger" show v-if="error">{{error}}</b-alert>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import auth from '../auth'
import axios from 'axios'
import Location from '@/components/Location'
import FieldError from '@/components/FieldError'
import categorias_de_clientes from '@/data/categorias-de-clientes.json'

export default {
  created() {
    if (this.$store.state.currentUser) {
      this.$router.replace('/carrinho')
    }
    setTimeout(() => { this.showForm = true }, 500);
  },
  computed: {
    cart() {
      return this.$store.state.cart
    }
  },
  data() {
    return {
      categorias_de_clientes,
      email: '',
      password: '',
      showForm: false,
      year: new Date().getFullYear(),
      active_view: 'login',
      form: {
        email: null,
        password: '',
        password_confirmation: '',
        name: '',
        cnpj: '',
        category: '',
        address: null,
        phone: ''
      }
    }
  },
  methods: {
    login() {
      this.error = false
      this.isLoading = true
      auth.login(this.email, this.password, response => {
        if (response.authenticated) {
          if (this.cart && this.cart.length) {
            this.$router.replace(this.$route.query.redirect || '/carrinho')
          } else {
            this.$router.replace(this.$route.query.redirect || '/pedidos')
          }
          const { _id: id, name, token } = response.currentUser;
          window.Dorothy.connectUser({ id, name }, token);

        } else {
          this.error = response.error
        }
        this.isLoading = false
      })
    },
    register() {
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.isSending = true
          this.error = false

          axios({
            method: 'POST',
            url: '/register',
            data: this.form
          }).then(resp => {
            var user = resp.data
            if (user && user._id) {
              auth.login(this.form.email, this.form.password, response => {
                if (response.authenticated) {
                  this.notify("Cadastro realizado com sucesso")
                  if (this.cart && this.cart.length) {
                    this.$router.replace(this.$route.query.redirect || '/carrinho')
                  } else {
                    this.$router.replace(this.$route.query.redirect || '/pedidos')
                  }
                } else {
                  this.error = response.error
                }
                this.isLoading = false
              })
            }
            this.isSending = false
          }).catch(this.showError)
        }
      })
    },
    setView(view) {
      this.active_view = view
    },
    setAddress(address) {
      this.form.address = address
    }
  },
  components: {
    Location,
    FieldError
  }
};
</script>
<style lang="sass" scoped>
  .login
    border-right: 1px solid #f0f0f0
</style>
